import React, { Component } from 'react';
import {
	CardNumberElement,
	CardExpiryElement,
	CardCVCElement,
} from 'react-stripe-elements';

import {
	TextBox,
	TextBoxDropdown,
	TextArea,
	CheckBox,
	CheckBoxHTML,
	DropdownList,
	TextBoxButton,
	DatePicker,
	CustomTimePicker,
	RadioGroup,
} from './inputs.js';
import DropUploadFiles from './drop-upload-files.js';
import TextboxButtonUploadFiles from './textbox-button-upload-files.js';
import AvatarUpload from './avatar-upload.js';
import visa from '../../assets/images/payments/visa.svg';

const FormTextBox = ({ field, form, ...props }) => (
	<TextBox {...field} {...form} {...props} />
);

const FormTextArea = ({ field, form, ...props }) => (
	<TextArea {...field} {...form} {...props} />
);

const FormCheckBox = ({ field, form, ...props }) => (
	<CheckBox {...field} {...form} {...props} />
);

class FormRadioGroup extends Component {
	handleOnChange = (value) => {
		const { form, field } = this.props;

		form.setFieldTouched(field.name, true);
		form.setFieldValue(field.name, value.value);
	};

	render() {
		const { field, form, ...props } = this.props;

		return (
			<RadioGroup
				{...field}
				{...form}
				{...props}
				onChange={this.handleOnChange}
			/>
		);
	}
}

const FormCheckBoxHTML = ({ field, form, ...props }) => (
	<CheckBoxHTML {...field} {...form} {...props} />
);

class FormDatePicker extends Component {
	state = {
		focused: false,
	};

	handleDatepickerChange = (value) => {
		const { form, field } = this.props;

		form.setFieldValue(field.name, value);
	};

	handleDatepickerFocus = ({ focused }) => {
		const { form, field } = this.props;

		if (this.state.focused && !focused) {
			form.setFieldTouched(field.name, true);
		}

		this.setState({ focused });
	};

	render() {
		const { field, form, ...props } = this.props;
		const { focused } = this.state;

		return (
			<DatePicker
				{...field}
				{...form}
				{...props}
				date={field.value || null}
				onChange={this.handleDatepickerChange}
				onFocusChange={this.handleDatepickerFocus}
				focused={focused}
			/>
		);
	}
}

class FormTimePicker extends Component {
	handleTimePickerChange = (value) => {
		const { form, field } = this.props;
		form.setFieldValue(field.name, value);
	};

	handleTimePickerClose = () => {
		const { form, field, onClose } = this.props;
		if (onClose) {
			onClose();
		}
		form.setFieldTouched(field.name, true);
	};

	render() {
		const { field, form, ...props } = this.props;

		return (
			<CustomTimePicker
				{...field}
				{...form}
				{...props}
				onChange={this.handleTimePickerChange}
				onClose={this.handleTimePickerClose}
			/>
		);
	}
}

const FormTextBoxButton = ({
	field, form, children, ...props
}) => (
	<TextBoxButton {...field} {...form} {...props}>
		{children}
	</TextBoxButton>
);

class FormDropdownList extends Component {
	handleDropdownListChange = (option) => {
		if (this.props.onChange) {
			this.props.onChange(option);
		}
		if (this.props.autocomplete) {
			this.props.form.setFieldValue(this.props.field.name, option);
		} else if (this.props.multi) {
			this.props.form.setFieldValue(
				this.props.field.name,
				option.map(opt => opt.value),
			);
		} else {
			this.props.form.setFieldValue(
				this.props.field.name,
				option ? option.value : null,
			);
		}
	};

	handleDropdownListBlur = () => {
		this.props.form.setFieldTouched(this.props.field.name, true);
	};

	render() {
		const { form, field } = this.props;

		return (
			<DropdownList
				{...field}
				{...form}
				{...this.props}
				onChange={this.handleDropdownListChange}
				onBlur={this.handleDropdownListBlur}
			/>
		);
	}
}

class FormDropUploadFiles extends Component {
	handleUploadFileComplete = (file) => {
		const filesList = [...this.props.field.value];
		filesList.push(file);

		this.props.form.setFieldValue(this.props.field.name, filesList);
	};

	handleRemoveFile = (fileId) => {
		const removedFileIndex = this.props.field.value.findIndex(
			f => f.id === fileId,
		);
		const filesList = [...this.props.field.value];
		filesList.splice(removedFileIndex, 1);

		this.props.form.setFieldValue(this.props.field.name, filesList);
	};

	render() {
		return (
			<DropUploadFiles
				{...this.props}
				handleUploadFileComplete={this.handleUploadFileComplete}
				handleRemoveFile={this.handleRemoveFile}
			/>
		);
	}
}

class FormTextboxButtonUploadFiles extends Component {
	handleFileChange = (file) => {
		this.props.form.setFieldValue(this.props.field.name, file);
	};

	render() {
		return (
			<TextboxButtonUploadFiles
				{...this.props}
				handleFileChange={this.handleFileChange}
			/>
		);
	}
}

class FormAvatarUpload extends Component {
	handleFileChange = (file) => {
		this.props.form.setFieldValue(this.props.field.name, file);
	};

	render() {
		return (
			<AvatarUpload {...this.props} handleFileChange={this.handleFileChange} />
		);
	}
}

class FormTextBoxDropdown extends Component {
	handleAmountChange = (event) => {
		const currentValue = this.props.form.values[this.props.field.name];
		currentValue.amount = event.target.value;

		this.props.form.setFieldValue(this.props.field.name, currentValue);
	};

	handleUnitChange = (unit) => {
		const currentValue = this.props.form.values[this.props.field.name];
		currentValue.unit = unit.value;

		this.props.form.setFieldValue(this.props.field.name, currentValue);
	};

	render() {
		return (
			<TextBoxDropdown
				{...this.props.field}
				{...this.props.form}
				{...this.props}
				handleAmountChange={this.handleAmountChange}
				handleUnitChange={this.handleUnitChange}
			/>
		);
	}
}

const createOptions = () => ({
	style: {
		base: {
			fontSize: '13px',
			color: 'rgba(0,14,81,0.8)',
			fontFamily: "'Montserrat', sans-serif",
		},
		invalid: {
			color: '#ed594d',
		},
	},
});


class FormDetailCardCVCElement extends Component {
	handleChange = (event) => {
		const { form, field } = this.props;
		const { name } = field;

		form.setFieldValue(name, event.complete && event.elementType === 'cardCvc');
	};

	render() {
		const {
			label,
			name,
			classNameField,
			optional,
		} = this.props;
		return (
			<div className={classNameField}>
				<label htmlFor={name}>
					<div className="label">
						{label}
						<span>{optional}</span>
					</div>
				</label>
				<div className="input">
					<CardCVCElement id={name} onChange={this.handleChange} {...createOptions()} />
				</div>
			</div>
		);
	}
}

class FormDetailCardNumber extends Component {
	handleChange = (event) => {
		const { form, field } = this.props;
		const { name } = field;

		form.setFieldValue(name, event.complete && event.elementType === 'cardNumber');
	};

	render() {
		const {
			label, name, classNameField, optional,
		} = this.props;

		return (
			<div className={classNameField}>
				<label htmlFor={name}>
					<div className="label">
						{label}
						<span>{optional}</span>
					</div>
				</label>
				<div className="input">
					<CardNumberElement
						id={name}
						onChange={this.handleChange}
						{...createOptions()}
					/>
					<label className="visa-input">
						<img src={visa} alt="visa" />
					</label>
				</div>
			</div>
		);
	}
}

class FormDetailCardExpiryElement extends Component {
	handleChange = (event) => {
		const { form, field } = this.props;
		const { name } = field;

		form.setFieldValue(name, event.complete && event.elementType === 'cardExpiry');
	};

	render() {
		const {
			label,
			name,
			classNameField,
			optional,
		} = this.props;
		return (
			<div className={classNameField}>
				<label htmlFor={name}>
					<div className="label">
						{label}
						<span>{optional}</span>
					</div>
				</label>
				<div className="input">
					<CardExpiryElement
						id={name}
						onChange={this.handleChange}
						{...createOptions()}
					/>
				</div>
			</div>
		);
	}
}


export {
	FormTextBox,
	FormTextArea,
	FormCheckBox,
	FormRadioGroup,
	FormCheckBoxHTML,
	FormDropdownList,
	FormTextBoxButton,
	FormDatePicker,
	FormTimePicker,
	FormDropUploadFiles,
	FormTextboxButtonUploadFiles,
	FormAvatarUpload,
	FormTextBoxDropdown,
	FormDetailCardNumber,
	FormDetailCardExpiryElement,
	FormDetailCardCVCElement,
};
